import { Button } from '@repo/ui/button'
import { useT } from '@repo/ui/hooks'
import { TooltipWrapper } from '@repo/ui/tooltip'
import { Trash2Icon } from 'lucide-react'

export function FilterTemplateDeleteButton({
  disabled,
  onDelete,
}: {
  disabled: boolean
  onDelete: () => void
}) {
  const { tc } = useT()
  return (
    <TooltipWrapper content={tc('delete', { cfl: true })}>
      <Button isSensitive size="icon" variant="ghost" onClick={onDelete} disabled={disabled}>
        <Trash2Icon className="size-4" />
      </Button>
    </TooltipWrapper>
  )
}
